<template>
  <component :is="_state.route" />
</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";
import MainView from "./views/MainView.vue";
import WizardView from "./views/WizardView.vue";
import { state } from "./store/state";
import SettingsView from "./views/SettingsView.vue";
import api from "./api/api";
import slon from "./api/slon";

export default defineComponent({
  name: "App",
  components: {
    MainView,
    WizardView,
    SettingsView,
  },
  setup() {
    const _state = state;
    const url = new URL(location.href);
    _state.setRouteFromPath(url.pathname);
    const salonId = url.searchParams.get("salon_id");
    const hash = url.searchParams.get("hash");
    if (salonId !== null) {
      _state.salon_id = +salonId;
    }
    if (hash) {
      _state.hash = hash;
    }

    const bindIframeEvent = () => {
      const interval = setInterval(() => {
        console.log("sending iframe_ready...");
        
        api.sendReadyStatus();
        api.getCurClient();
      }, 1500);
      window.addEventListener("message", function (event) {
        // console.log('ans',event.data.payload, {event});
        // can message back using event.source.postMessage(...)
        if (process.env.NODE_ENV === "development") {
          event.data.payload = {
            entity_type: "client",
            entity: {
              firstname: "Вячеслав",
              surname: "Дудоров",
              patronymic: "",
              phone: "",
              id: 270916489,
            },
          };
        }

        if (event.data.payload?.entity_type === "client"){
          clearInterval(interval);
          event.data.payload.entity.phone = event.data.payload.entity.phone.replace(/^(\+7|7)/, '8')
          _state.setClient(event.data.payload.entity);
        }
      });
    };

    if(_state.route !== 'SettingsView')
      bindIframeEvent();

    onMounted(async () => {

      if (!_state.apiKey && hash && salonId) {
        _state.apiKey = await api.getKey();
        if (_state.apiKey.length) {
          const cData = await slon.getInfo();
          if (!cData.status) {
            return;
          }

          _state.companyInfo = {
            id: cData.company.inn,
            name: cData.company.name,
            sign_left: +cData.signings,
          };
        }
      }
    });

    return {
      _state,
    };
  },
});
</script>

<style>
:root {
  --main-color: #ffa800;
  --main-accent: #ffcb00;
  --lines-color: #e0e3eb;
  --primary-dark: #71757f;
  --primary-black: #2b3134;
  --accent-positive: #29c235;
  --accent-danger: #f72c32;
}
* {
  padding: 0;
  margin: 0;
  font-family: "Inter", sans-serif;
  font-optical-sizing: auto;
  color: var(--primary-black);
}
h2 {
  font-weight: 500;
  font-size: 20px;
  text-align: center;
}
#app {
  padding: 40px 20px;
  max-width: 375px;
  font-size: 14px;
  margin: 0 auto;
}
.mb16 {
  margin-bottom: 16px;
}
.doc-title,
.title {
  margin-left: 12px;
}
</style>
